<template>
  <div class="materials">
    <table-list
      title="报名审核管理"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="list"
      :btns="btns(this)"
      :tabs="tabs"
      :default-active-tab="planState"
      :footer-btns="footerBtns(this)"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      :options="{ selection: true, operatesWidth: 120 }"
      :footer-tip="str"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @handleTabChange="handleTabChange"
    ></table-list>
    <LinkDialog ref="LinkDialog"></LinkDialog>
    <MaterialsLink ref="MaterialsLink"></MaterialsLink>
    <BatchCheck ref="BatchCheck" @success="handleBacthSuccessFn"></BatchCheck>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '分享邀请报名',
    method: _this.handleShareLink,
  },
]
// 底部按钮
const footerBtns = _this => [
  {
    label: '导出全部',
    method: _this.handleExport,
  },
  {
    label: '批量删除',
    method: _this.handleBacthDelete,
    icon: 'el-icon-delete',
    type: 'danger',
  },
  {
    label: '批量审核',
    method: _this.handleBacthCheckFn,
    isShow: _this.planState !== '1',
  },
  {
    label: '修改链接',
    method: _this.handleChangeLinkFn,
    isShow: _this.planState !== '3',
  },
]
// 搜索框配置
const searchForm = _this => [
  {
    label: '姓名/手机/身份证号',
    prop: 'filter',
  },
  {
    placeholder: '证书名称-级别',
    type: 'treeAllSelect',
    width: 120,
    prop: 'certifiterMap',
    options: _this.certifiterList,
    optionProps: {
      checkStrictly: true,
      value: 'jobId',
      label: 'jobName',
      children: 'levelList',
    },
  },
  {
    label: '公司名称',
    prop: 'company',
  },
  {
    label: '审核人',
    prop: 'checkUserName',
  },
  {
    placeholder: '创建时间',
    type: 'daypicker',
    prop: 'createTime',
  },
]
const columns = () => []
// 表格列配置
const columns1 = _this => [
  {
    prop: 'id',
    label: '序号',
    minWidth: 50,
  },
  {
    prop: 'name',
    label: '姓名',
    minWidth: 100,
    twoLines: true,
    render: (h, { row }) => {
      return [
        h(
          'p',
          {
            style: {
              color: '#3671BF',
              cursor: 'pointer',
            },
            on: {
              click: () => {
                _this.handleSingleCheckFn(row)
              },
            },
          },
          row.name,
        ),
      ]
    },
  },
  {
    prop: 'phone',
    label: '手机号',
    minWidth: 80,
  },
  {
    prop: 'idCard',
    label: '身份证',
    minWidth: 120,
  },
  {
    prop: 'idCardLocation',
    label: '身份证所在地',
    minWidth: 120,
  },
  {
    prop: 'jobName',
    label: '报考证书名称',
    minWidth: 120,
  },
  {
    prop: 'jobLevel',
    label: '级别',
    minWidth: 80,
  },
  {
    prop: 'company',
    label: '公司名称',
    minWidth: 120,
  },
  {
    prop: 'channel',
    label: '渠道',
    minWidth: 80,
  },
  {
    prop: 'saleUser',
    label: '业务员',
    minWidth: 80,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 120,
    sortdata: 1,
  },
]
const columns2 = _this => [
  {
    prop: 'name',
    label: '姓名',
    minWidth: 100,
    twoLines: true,
    render: (h, { row }) => {
      return [
        h(
          'el-button',
          {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                _this.handleDetailFn(row)
              },
            },
          },
          row.name,
        ),
      ]
    },
  },
  {
    prop: 'phone',
    label: '手机号',
    minWidth: 80,
  },
  {
    prop: 'idCard',
    label: '身份证',
    minWidth: 80,
  },
  {
    prop: 'idCardLocation',
    label: '身份证所在地',
    minWidth: 120,
  },
  {
    prop: 'jobName',
    label: '报考证书名称',
    minWidth: 120,
  },
  {
    prop: 'jobLevel',
    label: '级别',
    minWidth: 80,
  },
  {
    prop: 'company',
    label: '公司名称',
    minWidth: 120,
  },
  {
    prop: 'channel',
    label: '渠道',
    minWidth: 80,
  },
  {
    prop: 'saleUser',
    label: '业务员',
    minWidth: 80,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 120,
    sortdata: 1,
  },
  {
    prop: 'remark',
    label: '驳回原因',
    minWidth: 100,
  },
  {
    prop: 'checkTime',
    label: '驳回时间',
    minWidth: 120,
  },
]
const columns3 = _this => [
  {
    prop: 'id',
    label: '序号',
    minWidth: 80,
  },
  {
    prop: 'name',
    label: '姓名',
    minWidth: 100,
    twoLines: true,
    render: (h, { row }) => {
      return [
        h(
          'el-button',
          {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                _this.handleDetailFn(row)
              },
            },
          },
          row.name,
        ),
      ]
    },
  },
  {
    prop: 'phone',
    label: '手机号',
    minWidth: 80,
  },
  {
    prop: 'idCard',
    label: '身份证',
    minWidth: 80,
  },
  {
    prop: 'jobName',
    label: '报考证书名称',
    minWidth: 120,
  },
  {
    prop: 'jobLevel',
    label: '级别',
    minWidth: 80,
  },
  {
    prop: 'company',
    label: '公司名称',
    minWidth: 120,
  },
  {
    prop: 'channel',
    label: '渠道',
    minWidth: 80,
  },
  {
    prop: 'saleUser',
    label: '业务员',
    minWidth: 80,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 120,
    sortdata: 1,
  },
  {
    prop: 'checkUser',
    label: '审核人',
    minWidth: 80,
  },
  {
    prop: 'checkTime',
    label: '审核时间',
    minWidth: 120,
    sortdata: 2,
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleSingleCheckFn,
    label: '审核',
    isShow: () => _this.planState == '1',
  },
  {
    method: _this.handleDetailFn,
    label: '查看',
    isShow: () => _this.planState !== '1',
  },
]
import TableList from '@/components/TableList'
import to from 'await-to'
import LinkDialog from './components/linkShareDialog'
import BatchCheck from './components/batchCheck'
import MaterialsLink from './components/materialsLink'
import { filterJobLevel } from '@/api/exam'
import {
  materialsList,
  materialsFinishList,
  materialsListExport,
  materialsFinishListExport,
  batchDeleteList,
} from '@/api/apply'
export default {
  name: 'CardsManage',
  components: {
    TableList,
    LinkDialog,
    BatchCheck,
    MaterialsLink,
  },
  data() {
    return {
      searchForm,
      btns,
      footerBtns,
      columns,
      columns1,
      columns2,
      columns3,
      operates,
      loading: false,
      list: [],
      selectList: [],
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      queryParams: {},
      tabs: [],
      planState: '1',
      certifiterList: [],
      listNum: 0,
      lostListNum: 0,
      finishListNum: 0,
      str: '',
    }
  },
  mounted() {
    this.columns = this.columns1
    this.getJobLevel()
    this.handleGetMaterialsListFn()
    this.handleGetListFn()
  },
  methods: {
    handleBacthSuccessFn() {
      this.planState = '1'
      this.columns = this.columns1
      this.getJobLevel()
      this.handleGetMaterialsListFn()
      this.handleGetListFn()
    },
    async getJobLevel() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.certifiterList = res.data
    },
    //查询数量
    async handleGetMaterialsListFn() {
      const { current, size } = this.pager
      const [res, err] = await to(materialsList({ current, size, ...this.queryParams }))
      if (err) return this.$message.warning(err.msg)
      this.listNum = res.data.total
      this.handleGetMaterialLostListFn()
    },
    //审核完成
    async handleGetMaterialLostListFn() {
      const { current, size } = this.pager
      const [res, err] = await to(
        materialsFinishList({ current, size, status: 2, ...this.queryParams }),
      )
      if (err) return this.$message.warning(err.msg)
      this.lostListNum = res.data.total
      this.handleGetMaterialFinishListFn()
    },
    //驳回待修改
    async handleGetMaterialFinishListFn() {
      const { current, size } = this.pager
      const [res, err] = await to(
        materialsFinishList({ current, size, status: 3, ...this.queryParams }),
      )
      if (err) return this.$message.warning(err.msg)
      this.finishListNum = res.data.total
      this.handleGetListNumFn()
    },
    //赋值tab数量
    handleGetListNumFn() {
      this.tabs = [
        {
          label: '审批中（' + (this.listNum || 0) + '）',
          name: '1',
        },
        {
          label: '审核完成（' + (this.lostListNum || 0) + '）',
          name: '2',
        },
        {
          label: '驳回待修改（' + (this.finishListNum || 0) + '）',
          name: '3',
        },
      ]
    },
    //审批中列表
    async handleGetListFn() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(materialsList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.list = res.data.list
      this.pager.total = res.data.total
    },
    //其他的列表
    async handleGetOtherListFn(e) {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(
        materialsFinishList({ current, size, status: e, ...this.queryParams }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.list = res.data.list
      this.pager.total = res.data.total
    },
    //分享邀请报名
    handleShareLink() {
      this.$refs.LinkDialog.show()
    },
    //修改链接
    handleChangeLinkFn() {
      this.$refs.MaterialsLink.show()
    },
    //导出全部
    async handleExport() {
      if (this.planState == '1') {
        this.handleCheckingExport()
      } else {
        this.handleFinishExport(this.planState)
      }
    },
    //审批中导出
    async handleCheckingExport() {
      let arr = []
      if (this.selectList.length) this.selectList.map(v => arr.push(v.id))
      const { current, size } = this.pager
      const [res, err] = await to(
        materialsListExport({
          current,
          size,
          idList: arr,
          ...this.queryParams,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '报名资料.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    //失败时导出
    async handleFinishExport(e) {
      let arr = []
      if (this.selectList.length) this.selectList.map(v => arr.push(v.id))
      const { current, size } = this.pager
      const [res, err] = await to(
        materialsFinishListExport({
          current,
          size,
          idList: arr,
          status: e,
          ...this.queryParams,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '报名资料.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    //删除
    async handleBacthDelete() {
      let arr = []
      if (this.selectList.length == 0) return this.$message.warning('请选择要删除的数据')
      this.selectList.map(v => arr.push(v.id))
      this.$confirm(`您确定要删除吗？删除后将无法恢复`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(batchDeleteList({ idList: arr }))
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          this.handleBacthSuccessFn()
        })
        .catch(() => {})
    },
    //批量审核
    handleBacthCheckFn() {
      if (this.selectList.length == 0) return this.$message.warning('请先选择报名资料')
      this.$refs.BatchCheck.show(this.selectList)
    },
    //审核
    handleSingleCheckFn(row) {
      this.$router.push({ path: '/apply/materialsDetail', query: { id: row.id } })
    },
    //查看
    handleDetailFn(row) {
      this.$router.push({ path: '/apply/materialsDetail', query: { id: row.id, readonly: 1 } })
    },
    // 查询按钮
    onSearch(queryParams) {
      if (queryParams.certifiterMap && queryParams.certifiterMap.length) {
        if (queryParams.certifiterMap.length == 1) {
          queryParams.jobId = String(queryParams.certifiterMap[0])
          queryParams.jobLevel = ''
        } else if (queryParams.certifiterMap.length > 1) {
          queryParams.jobId = String(queryParams.certifiterMap[0])
          queryParams.jobLevel = String(
            queryParams.certifiterMap[queryParams.certifiterMap.length - 1],
          )
        } else {
          queryParams.jobId = ''
          queryParams.jobLevel = ''
        }
      } else {
        queryParams.jobId = ''
        queryParams.jobLevel = ''
      }
      if (queryParams.createTime && queryParams.createTime.length) {
        queryParams.start = queryParams.createTime[0]
        queryParams.end = queryParams.createTime[1]
      } else {
        queryParams.start = ''
        queryParams.end = ''
      }
      this.pager.current = 1
      this.queryParams = queryParams
      if (this.planState == '1') {
        this.handleGetListFn()
      } else {
        this.handleGetOtherListFn(this.planState)
      }
      this.handleGetMaterialsListFn()
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      if (this.planState == '1') {
        this.handleGetListFn()
      } else {
        this.handleGetOtherListFn(this.planState)
      }
    },
    handleCurrentChange(current) {
      this.pager.current = current
      if (this.planState == '1') {
        this.handleGetListFn()
      } else {
        this.handleGetOtherListFn(this.planState)
      }
    },
    handleSelectionChange(val) {
      this.selectList = val
    },
    handleTabChange(e) {
      if (e == '1') {
        this.columns = this.columns1
        this.str = ''
      } else if (e == '3') {
        this.columns = this.columns2
        this.str = '分享记录链接给学员，学员修改后信息回扭转到审核中'
      } else if (e == '2') {
        this.columns = this.columns3
        this.str = ''
      }
      this.pager.current = 1
      this.planState = e
      if (this.planState == '1') {
        this.handleGetListFn()
      } else {
        this.handleGetOtherListFn(this.planState)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.materials {
  ::v-deep .table-list {
    .el-tabs {
      background-color: #fff;
      .el-tabs__item {
        padding: 0 12px;
        width: 180px;
        text-align: center;
      }
    }
    .table-main {
      height: calc(100% - 178px) !important;
    }
    .el-table__body-wrapper {
      height: 510px !important;
    }
    .form {
      .el-cascader .el-input,
      .el-input .el-select {
        width: 250px !important;
        .el-input__inner {
          width: 250px !important;
        }
      }
      .el-date-editor {
        width: 250px !important;
      }
    }
  }
}
</style>
